"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _queryBuilder = _interopRequireDefault(require("@sprinx/query-builder"));

var _useServiceCall = _interopRequireDefault(require("../useServiceCall"));

/**
 * Volani API sluzby pro ziskani strankovaneho seznamu entit.
 *
 * Pri mountu komponenty se automaticky spusti akce jen v pripade, ze je definovana alespon jedna z hodnot
 * `initialFilter`, `initialOrder`, `initialPagination`.
 *
 * @param {Object} [options] Nastaveni volani
 * @param {string} [options.clientCode='api'] string identifikujici pouziteho clienta. Client je definovan pomoci
 *       rodiny provideru spojeni `ConnectServer`.
 * @param {Array} [options.initialArgs] pokud !== `undefined` zavola se `action` okamzite po namontovani komponenty.
 *       V opacnem pripade se ceka na manualni zavolani akce
 * @param {'none' | 'success' | 'warning' | 'error'} [options.meaning='none'] identifikuje vyznam akce. Dle vyznamu je
 *       nastaveno napriklad podbarveni toastu.
 * @param {boolean} [options.returnOnlyAction=false] pokud je `true` vysledkem je samotna akce
 *
 * @param {string} serviceName Nazev sluzby.
 *
 * @param {Object} [initialFilter] Inicialni data entity. Vhodne v pripade, ze jsme data ziskali ze `state`
 *
 * @param {Object} [initialOrder] Inicialni data entity. Vhodne v pripade, ze jsme data ziskali ze `state`
 *
 * @param {Object} [initialPagination] Inicialni data entity. Vhodne v pripade, ze jsme data ziskali ze `state`
 *
 *
 * @returns {(...args) => Promise | [result, error, loading, (...args) => Promis]} Pokud je `returnOnlyAction === true`
 *   vraci samotnou akci. V opacnem pripade vraci `tuple` s:
 *     - `result` - vysledkem volani sluzby. Default `undefined`.
 *     - `error` - chyba po volani sluzby. Default `null`.
 *     - `loading` - indikator loadovani, ktery je v prubehu loadovani `true`. Default `true`
 */
function useServiceCallList(options, serviceName, initialFilter, initialOrder, initialPagination) {
  return (0, _useServiceCall.default)((0, _extends2.default)({
    // zavolaj sluzbu len v pripade, ze mame nejake inicialne nastavenia,
    // v opacnom pripade cakaj na externe volanie.
    initialArgs: initialFilter || initialOrder || initialPagination ? [initialFilter, initialOrder, initialPagination] : undefined,
    defaultResult: {
      rows: [],
      total: 0,
      page: (initialPagination || {}).page || 1,
      pageSize: (initialPagination || {}).rowsPerPage || 10,
      totalPages: 1
    }
  }, options), /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(client, filter, order, pagination) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", client.list(serviceName, (0, _queryBuilder.default)(null, filter, order, pagination)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }());
}

var _default = useServiceCallList;
exports.default = _default;